// import mithril from 'mithril'
import routes from 'core/routes'

import 'core/sass/style.sass'

var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
               navigator.userAgent &&
               navigator.userAgent.indexOf('CriOS') == -1 &&
               navigator.userAgent.indexOf('FxiOS') == -1


const appContainer = document.getElementById('app')
if (isSafari) appContainer.classList.add('is-safari')
appContainer.id = 'app'
document.body.appendChild(appContainer)
routes.init(appContainer)
